import { useEffect } from "react";
import CasesSection from "../../components/sections/CasesSection/CasesOverview";
import FooterSection from "../../components/sections/FooterSection";
import HeroSection from "../../components/sections/HeroSection";
import NewsSection from "../../components/sections/NewsSection";
import PartnerSection from "../../components/sections/PartnerSection";
import ProjectsSection from "../../components/sections/ProjectsSection";
import NavBar from "../communs/NavBar";
import NationalDayModal from "../../components/nationalDayModal/NationalDayModal";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import { getRatingDetails } from "../../apis/actions/moyasar.actions";
import {
  setRatingVisible,
  setResModel,
  setResIds,
  setRatedPartnerId,
} from "../../apis/slices/ratingSlice";

const Home = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { access_token } = useParams<{ access_token: string }>();
  const { data: RatingResponse } = useSelector(
    (state: RootState) => state.rating.RatingResponse
  );

  useEffect(() => {
    if (access_token) {
      dispatch(getRatingDetails(access_token));
    }
  }, [dispatch, access_token]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (RatingResponse && RatingResponse?.consumed ==false) {
      dispatch(setRatingVisible(true));
      dispatch(setResModel("association.donation.amount"));
      dispatch(setResIds([RatingResponse?.id]));
      dispatch(setRatedPartnerId(RatingResponse?.donor_id));
    }
  }, [dispatch, RatingResponse]);
  return (
    <>
      <NavBar variant="homePage" className="takaful--navbar-divider-home" />
      <NationalDayModal />
      <HeroSection />
      <CasesSection />
      <ProjectsSection />
      {/* <StatisticSection />*/}
      <NewsSection />
      <PartnerSection />
      <FooterSection />
    </>
  );
};

export default Home;
